﻿import { DateTime, Settings } from "luxon";

const isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?$/;
const dateOnlyFormat = /^\d{4}-\d{2}-\d{2}$/;
const timeOnlyFormat = /^\d{2}:\d{2}:\d{2}(?:\.\d+)?$/;

function isDateOnlyString(value: any): boolean {
  return typeof value === "string" && dateOnlyFormat.test(value);
}

function isIsoDateTimeString(value: any): boolean {
  return typeof value === "string" && isoDateFormat.test(value);
}

function isTimeOnlyString(value: any): boolean {
  return typeof value === "string" && timeOnlyFormat.test(value);
}

function parseTimeOnly(timestr: string): DateTime {
  // force a full ISO timestamp at epoch date
  const [hh, mm, ss] = timestr.split(":");
  const rest = ss.includes(".") ? "" : ".000";
  return DateTime.utc(1970, 1, 1, Number(hh), Number(mm), Number(ss), Number(rest)).setZone(Settings.defaultZone);
}

export function parseDateTimes(body: any): any {
  if (body === null || typeof body !== "object" || body === undefined) return;

  if (Array.isArray(body)) {
    return body.map(item => parseDateTimes(item)); // ← safer to return new array
  }

  for (const key of Object.keys(body)) {
    const value = body[key];

    if (isIsoDateTimeString(value)) {
      const dt = value.match(/Z|[+-]\d{2}:\d{2}$/)
        ? DateTime.fromISO(value).setZone(Settings.defaultZone)
        : DateTime.fromISO(value, { zone: 'utc' }).setZone(Settings.defaultZone);
      body[key] = dt.isValid ? dt : value; // fallback to raw value if invalid
    } else if (isDateOnlyString(value)) {
      const [year, month, day] = value.split('-').map(Number);
      const dt = DateTime.utc(year, month, day, 0, 0, 0); // real UTC, not fixed offset
      body[key] = dt.isValid ? dt : value;
    } else if (isTimeOnlyString(value)) {
      body[key] = parseTimeOnly(value);
    } else if (typeof value === "object") {
      parseDateTimes(value);
    }
  }
}